<div class="responsive-card flex-column" [style.gap.rem]="spousalWaiver ? 1.5 : 1">
  <span class="title-md" i18n>
    {{ spousalWaiver?.governingJurisdictionId | governingJurisdictionName }} Spousal Waiver
  </span>
  <div class="d-flex flex-column gap-4" *ngIf="spousalWaiver?.attachment as attachment; else empty">
    <app-file-list-item
      [fileLabel]="waiverTypeId | spousalWaiverTypeLabel"
      [fileName]="attachment.fileName"
      [fileSizeInBytes]="attachment.fileSize"
      [previewUrl]="attachment.links | attachmentLink"
      action="download" />
    <div class="review-entry-grid" *ngIf="createdInPortalTypeId === PortalTypeIdEnum.Internal">
      <app-review-entry label="Date Signed" i18n-label [value]="spousalWaiver?.signedDate | date : 'MMM d, yyyy'" />
      <app-review-entry
        label="Effective Date"
        i18n-label
        [value]="spousalWaiver?.effectiveDate | date : 'MMM d, yyyy'" />
    </div>
  </div>
</div>

<ng-template #empty>
  <div class="d-flex flex-column gap-3">
    <div class="empty" i18n>
      A spousal waiver wasn’t included in the submission. You must provide the form by mail, email or fax instead.
    </div>
    <div class="empty" i18n>
      Required documents and accompanying instructions can be found
      <button
        type="button"
        class="link-button no-style-button"
        (click)="navigateToExternalForms()"
        aria-label="Open the CSS form library"
        i18n-aria-label>
        here</button
      >.
    </div>
  </div>
</ng-template>
